import { useEffect, useState } from 'react';
import { apiAssetsHost } from './ApiService';
import { ApiLocalStorage } from './ApiLocalStorage';
import { convertTokens } from './useResolveDesignTokens';

export const THEME_STORAGE_KEY = 'theme';

interface ThemeData {
    token?: Record<string, any>;
    designTokens?: Record<string, any>;
    components?: Record<string, any>;
    [key: string]: any;
}

export const useTheme = () => {
    const [theme, setTheme] = useState<ThemeData>(() =>
        ApiLocalStorage.get(THEME_STORAGE_KEY) || {}
    );
    const [isLoading, setIsLoading] = useState(true);
  
    useEffect(() => {
        setIsLoading(true);
        apiAssetsHost.get<ThemeData>('theme/default.json')
            .then((response) => {
                const data = response.data || response;

                if (!data || Object.keys(data).length === 0) {
                    throw new Error('Tema não encontrado');
                }

                const convertedTokens = convertTokens(data.token, data.designTokens);
                const convertedComponents = convertTokens(data.components, convertedTokens);
                
                const finalTheme = {
                    ...data,
                    token: { ...convertedTokens },
                    components: { ...convertedComponents }
                };

                ApiLocalStorage.set(THEME_STORAGE_KEY, finalTheme);
                setTheme(finalTheme);
            })
            .catch(() => {
                // Se houver erro, mantem o tema do localStorage se existir
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const updateTheme = (result: ThemeData) => {
        ApiLocalStorage.set(THEME_STORAGE_KEY, result);
        setTheme(result);
    };
  
    return { theme, updateTheme, isLoading };
};
